<template src="./Index.html">
</template>


<script>
import AddView from './actions/Add.vue';
import EditView from "./actions/Edit.vue";
import DetailsView from "./actions/Details.vue";

export default {
  components: {
    AddView,
    EditView,
    DetailsView,
  },
  created() {
    this.getAll();
    
  },
  computed: {
    pageCount() {
      return Math.ceil(
        this.$store.state.patients.totalItems / this.filters.pageSize
      );
    },
    patients() {
      return this.$store.state.patients.patients;
    },

  },

  data() {
    return {
      permissions: this.$patientsManagementPermissions.PatientsPermissions,

      view: 0,

      dialog: false,
      dialogType: null,
      dialogMessage: "",

      filters: {
        page: 1,
        pageSize: 10,
        fullName: null,
        phoneNo: null,
      },
      headers: [
        { text: 'رقم الملف', value: 'fileNo' },
        { text: 'الاسم بالكامل', value: 'fullName' },
        { text: 'رقم الهاتف', value: 'phoneNo' },
        // { text: "مسجل بواسطة", value: "createdBy", sortable: false },
        { text: "تاريخ التسجيل", value: "createdOn", sortable: false },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
    
      itemId: 0,
    };
  },
  methods: {
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("patients/getAll", this.filters);

    },

    addItem() {
      this.view = 1;
    },
    viewItem(item) {
      this.itemId = item.id;
      this.view = 3;
      // Implement view logic
    },
    editItem(item) {
      this.itemId = item.id;
      this.view = 2;
      // Implement edit logic
    },
    showDialog(item, type) {
      switch (type) {
        case "delete":
          this.dialogMessage = "هل انت متأكد من رغبتك حذف البيانات";
          break;
        // case "lock":
        //     this.dialogMessage = "هل انت متأكد من رغبتك تجميد البيانات";
        //     break;
        // case "unlock":
        //     this.dialogMessage = "هل انت متأكد من رغبتك تفعيل البيانات";
        //     break;
      }
      this.dialogType = type;
      this.itemId = item.id;
      this.dialog = true;
    },

    confirmDialog() {
      this.$store.dispatch(`patients/${this.dialogType}`, this.itemId);
      this.cancelDialog();
    },

    cancelDialog() {
      this.dialog = false;
      this.itemId = 0;
      this.dialogMessage = "";
      this.dialogType = null;
    },
    back() {
      this.view = 0;
    }
  },
};
</script>

<style scoped></style>